/**
 * Typed label interface for Data Grid i18n.
 * Components accept an optional `labels` prop — English defaults built-in.
 * Keys use `dg` prefix to avoid collisions with Advanced Table `adv` prefix.
 */

export interface DataGridLabels {
  // Edit mode banner
  dgEditBanner: string;

  // Context menu
  dgCopy: string;
  dgPaste: string;
  dgClearCell: string;
  dgViewDetail: string;

  // Paste dialog
  dgPasteTitle: string;
  dgPasteDescription: string;
  dgPasteCurrent: string;
  dgPasteNew: string;
  dgPasteMore: string;
  dgPasteSaving: string;
  dgPasteApply: string;
  dgPasteSavingBtn: string;
  dgCancel: string;

  // Toolbar
  dgToggleEditMode: string;

  // Conflict
  dgConflictTooltip: string;

  // Keyboard help
  dgKeyboardHelp: string;
  dgNavigation: string;
  dgEditing: string;
  dgClipboard: string;
  dgUndoRedo: string;
  dgShortcutTab: string;
  dgShortcutEnter: string;
  dgShortcutEscape: string;
  dgShortcutArrows: string;
  dgShortcutHome: string;
  dgShortcutEnd: string;
  dgShortcutCtrlHome: string;
  dgShortcutCtrlEnd: string;
  dgShortcutPageUp: string;
  dgShortcutPageDown: string;
  dgShortcutCtrlZ: string;
  dgShortcutCtrlShiftZ: string;
  dgShortcutCtrlC: string;
  dgShortcutCtrlV: string;
  dgShortcutCtrlX: string;
  dgShortcutQuestion: string;
  // Selection (Plan 124, Epic 03)
  dgSelection: string;
  dgShortcutShiftArrows: string;
  dgShortcutShiftCtrlArrows: string;
  dgShortcutShiftHome: string;
  dgShortcutShiftEnd: string;
  // Range operations (Plan 124, Epic 04)
  dgCut: string;
  dgUndoAction: string;
  dgCleared: string;
  dgCells: string;
  dgShortcutDelete: string;
}

export const DEFAULT_DATA_GRID_LABELS: DataGridLabels = {
  // Edit mode banner
  dgEditBanner: 'Editing mode — changes save automatically',

  // Context menu
  dgCopy: 'Copy',
  dgPaste: 'Paste',
  dgClearCell: 'Clear cell',
  dgViewDetail: 'View detail',

  // Paste dialog
  dgPasteTitle: 'Paste values',
  dgPasteDescription: 'Review the changes below before applying.',
  dgPasteCurrent: 'Current',
  dgPasteNew: 'New',
  dgPasteMore: 'more',
  dgPasteSaving: 'Saving',
  dgPasteApply: 'Apply',
  dgPasteSavingBtn: 'Saving...',
  dgCancel: 'Cancel',

  // Toolbar
  dgToggleEditMode: 'Toggle edit mode',

  // Conflict
  dgConflictTooltip: 'Modified by another user',

  // Keyboard help
  dgKeyboardHelp: 'Keyboard shortcuts',
  dgNavigation: 'Navigation',
  dgEditing: 'Editing',
  dgClipboard: 'Clipboard',
  dgUndoRedo: 'Undo / Redo',
  dgShortcutTab: 'Next / previous cell',
  dgShortcutEnter: 'Move down',
  dgShortcutEscape: 'Cancel edit',
  dgShortcutArrows: 'Navigate cells',
  dgShortcutHome: 'First cell in row',
  dgShortcutEnd: 'Last cell in row',
  dgShortcutCtrlHome: 'First cell in table',
  dgShortcutCtrlEnd: 'Last cell in table',
  dgShortcutPageUp: 'Page up',
  dgShortcutPageDown: 'Page down',
  dgShortcutCtrlZ: 'Undo',
  dgShortcutCtrlShiftZ: 'Redo',
  dgShortcutCtrlC: 'Copy cell',
  dgShortcutCtrlV: 'Paste',
  dgShortcutCtrlX: 'Cut cell',
  dgShortcutQuestion: 'Show shortcuts',
  // Selection (Plan 124, Epic 03)
  dgSelection: 'Selection',
  dgShortcutShiftArrows: 'Extend selection',
  dgShortcutShiftCtrlArrows: 'Extend to edge',
  dgShortcutShiftHome: 'Extend to row start',
  dgShortcutShiftEnd: 'Extend to row end',
  // Range operations (Plan 124, Epic 04)
  dgCut: 'Cut',
  dgUndoAction: 'Undo',
  dgCleared: 'Cleared',
  dgCells: 'cells',
  dgShortcutDelete: 'Clear selected cells',
};
